import script from "./timbreMarket.vue?vue&type=script&setup=true&lang=ts"
export * from "./timbreMarket.vue?vue&type=script&setup=true&lang=ts"

import "./timbreMarket.vue?vue&type=style&index=0&id=3f0febb4&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0febb4"]])

export default __exports__